import React from 'react'
import './Button.css'
import { Link } from 'react-router-dom'

const Button = ({
  children,
  variant = 'primary',
  href,
  onClick,
  external = false,
  sameWindow = false,
  className = '',
  ...props
}) => {
  const buttonClass = `btn btn-${variant} ${className}`

  if (href) {
    const linkProps = {
      className: buttonClass,
      onClick,
      ...props
    }

    // Add security attributes for external links (unless sameWindow is true)
    if (external) {
      if (!sameWindow) {
        linkProps.target = '_blank'
        linkProps.rel = 'noopener noreferrer'
      }

      return <a {...linkProps} href={href}>{children}</a>
    }

    return (
      <Link {...linkProps} to={href}>
        {children}
      </Link>
    )
  }

  return (
    <button className={buttonClass} onClick={onClick} {...props}>
      {children}
    </button>
  )
}

export default Button
